












import {Component, Prop, Vue} from "vue-property-decorator";
import {MediaGridSorting} from "@share/web-conferences/types/media/MediaGridSorting";

@Component({
    name: "MediaGridHeader"
})
export default class MediaGridHeader extends Vue {
    @Prop() sortableFields: string[];
    @Prop({default: {}}) sorting: MediaGridSorting;
    headers = ['preview', 'filename', 'date added', ''];

    isHeaderSortable(header: string) {
        return this.sortableFields.indexOf(header) >= 0;
    }

    onClick(header: string)
    {
        if (this.isHeaderSortable(header)) {
            this.$emit('changeSort', header);
        }
    }
}
